import { ErrorHandler } from "./with-error-handler";

export interface JsonErroHandlerFallback {
    onError(error: Error): void;
}

export interface JsonErrorHandlerDelegate {
    onJsonError(error: object): string | undefined;
}

export class JsonErrorHandler implements ErrorHandler {

    private fallback: ErrorHandler;
    public readonly delegates: JsonErrorHandlerDelegate[] = [];

    withFallback(fallback: ErrorHandler) {
        this.fallback = fallback;
        return this;
    }

    onError(error: Response | Error) {
        if (error instanceof Error || error.status === 500) // Neither of these responses are JSON errors
            this.checkError(this.fallback?.onError(error));
        else return error.json().then((data: object) => {
            this.delegates.forEach(delegate => this.checkError(delegate.onJsonError(data)));
        });
    }

    private checkError(error?: string) {
        if (error) {
            throw new Error(error);
        }
    }
}

